import { combineReducers } from 'redux';

import meteringProfiles from './meteringProfiles/reducer';

export default combineReducers({
  meteringProfiles,
});
